import { render, staticRenderFns } from "./VenueDetails.vue?vue&type=template&id=362338f9&"
import script from "./VenueDetails.vue?vue&type=script&lang=js&"
export * from "./VenueDetails.vue?vue&type=script&lang=js&"
import style0 from "./VenueDetails.vue?vue&type=style&index=0&id=362338f9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports